import { operatorClient, shippingClient } from 'domain/HttpClients';
import { doGet, doPatch, doPost } from 'circe/Http/saga';

/**
 *
 * @param itineraryId
 * @param headers
 * @returns {*}
 */
export const fetch = (itineraryId) =>
  operatorClient.Get(`/api/fleetowner/itineraries/${itineraryId}`).send();

/**
 *
 * @param itineraryId
 * @param payload
 * @param headers
 * @returns {*}
 */
export const complete = (itineraryId, payload) =>
  operatorClient
    .Post(`/api/fleetowner/itineraries/${itineraryId}/complete`)
    .withData(payload)
    .send();

/**
 *
 * @param itineraryId
 * @param payload
 * @param headers
 * @returns {*}
 */
export const confirmCash = (itineraryId, payload) =>
  operatorClient
    .Post(`/api/fleetowner/itineraries/${itineraryId}/confirm-cash-collected`)
    .withData(payload)
    .send();

/**
 *
 * @param itineraryId
 * @param payload
 * @param headers
 * @returns {*}
 */
export const confirmReceived = (itineraryId, payload) =>
  operatorClient
    .Post(`/api/fleetowner/itineraries/${itineraryId}/confirm-receive-shipments`)
    .withData(payload)
    .send();

/**
 *
 * @param itineraryId
 * @param queryParams
 * @param headers
 * @returns {*}
 */
export const attachToItinerary = (itineraryId, queryParams) =>
  operatorClient
    .Post(`/api/itineraries/${itineraryId}/add-shipment`)
    .withParams(queryParams)
    .send();

/**
 *
 * @param itineraryId
 * @param queryParams
 * @param headers
 * @returns {*}
 */
export const deattachFromItinerary = (itineraryId, queryParams) =>
  operatorClient
    .Patch(`/api/itineraries/${itineraryId}/remove-shipment`)
    .withParams(queryParams)
    .send();

/**
 *
 * @param itineraryId
 * @param queryParams
 * @param headers
 * @returns {*}
 */
export const rearrangeShipments = (itineraryId, queryParams) =>
  operatorClient
    .Patch(`/api/itineraries/${itineraryId}/rearrange-stops`)
    .withParams(queryParams)
    .send();

export const assignToDriver = ({ driverId, fleetId, itineraryId, vehicleId }) =>
  operatorClient
    .Post('/api/itineraries/transfer')
    .withData({
      driverId,
      fleetId,
      itineraryId,
      vehicleId,
    })
    .send();
export const updateRecipient = (payload, headers) =>
  doPost(
    '/api/masheed/single-forecast-sales-order/assign-shipments',
    payload,
    headers,
    {},
    OPERATIONS_EDGE,
    false,
    true,
  );

export const updateActual = async (shipmentId, actualArrivalDate, actualDeliveryDate) => {
  const arrivalDate = dateToISO(actualArrivalDate);
  const deliveryDate = dateToISO(actualDeliveryDate);
  try {
    const response = operatorClient
      .Post('/api/shipments/adjust-actuals')
      .withData({
        actualArrivalDate: arrivalDate,
        actualDeliveryDate: deliveryDate,
        shipmentIds: [`${shipmentId}`],
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const cancelShipments = (shipmentIds, reason) =>
  shippingClient
    .Post('/api/shipments/cancel')
    .withData(shipmentIds, reason)
    .send();

export const uploadConfirmations = async (itineraryId, fileNames, event) => {
  const response = await operatorClient
    .Post(`/api/itineraries/${itineraryId}/confirmations`)
    .withData({
      message: null,
      urls: fileNames,
      coordinate: null,
      confirmationEvent: event,
    })
    .send();
  return response;
};

export const uploadConfirmationsWithShipment = async (shipmentId, fileNames, event) => {
  const response = await operatorClient
    .Post(`/api/shipments/${shipmentId}/confirmations`)
    .withData({
      message: null,
      urls: fileNames,
      coordinate: null,
      confirmationEvent: event,
    })
    .send();
  return response;
};

export const createBayanOfTrip = async (itineraryId) => {
  const response = await operatorClient
    .Post('/api/itineraries/bayan')
    .withParams({
      itineraryId,
    })
    .send();
  return response;
};

export const addReturnStopToTrip = async (itineraryId, returnAddress) => {
  try {
    const response = await operatorClient
      .Patch(`/api/itineraries/${itineraryId}/add-return-stop`)
      .withParams({ returnAddressCode: returnAddress })
      .send();
    return response;
  } catch (e) {
    console.error(e);
    return '';
  }
};

export const cancelRejectedItem = async (shipmentId, itemId, itineraryId, reason) => {
  const response = await operatorClient
    .Post(`/api/shipments/${shipmentId}/cancel-rejected-item`)
    .withData({
      itemId: itemId,
      itineraryId: itineraryId,
      reason: reason,
    })
    .send();
  return response;
};

export const cancelBayanOfTrip = async (itineraryId, reasonId) => {
  const response = await operatorClient
    .Post('/api/itineraries/bayan/cancel')
    .withParams({
      itineraryId,
      reasonId,
    })
    .send();
  return response;
};

export const removeBulkFromRoute = async (shipmentIds, itineraryId, validate = true) => {
  const response = await operatorClient
    .Patch(`/api/itineraries/${itineraryId}/remove-shipment`)
    .withParams({
      shipmentId: shipmentIds,
      enableValidation: validate,
    })
    .send();
  return response;
};
export const closeBayanOfTrip = async (itineraryId) => {
  const response = await operatorClient
    .Post('/api/itineraries/bayan/close')
    .withParams({
      itineraryId,
    })
    .send();
  return response;
};

export const viewBayanOfTrip = async (itineraryId, forceGenerate) => {
  const response = await operatorClient
    .Get('/api/itineraries/bayan/print')
    .withParams({
      itineraryId,
      forceGenerate,
    })
    .send();
  return response;
};
export const getTripEvents = async (itineraryId) => {
  try {
    const response = await operatorClient
      .Get(`/api/itineraries/${itineraryId}/event/summary`)
      .send();
    return response?.events;
  } catch (e) {
    return [];
  }
};

export const changeResource = async (itineraryId, driverId, enableValidation = true) => {
  const response = await operatorClient
    .Post('api/itineraries/unblock-trip')
    .withData({
      message: 'Changed from the UI',
      driverId,
      itineraryId,
      enableValidation,
    })
    .send();

  return response;
};

export const getFlags = async (id) => {
  try {
    const response = await operatorClient.Get(`/api/itineraries/${id}/flags`).send();

    return response;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const revertCompleted = async (message = 'Reverted from UI', itineraryId) => {
  const response = await operatorClient
    .Put(`/api/itineraries/${itineraryId}/revert-completed`)
    .withData({
      message,
    })
    .send();

  return response;
};

export const revertStatus = async (message = 'Resumed from UI', itineraryId) => {
  const response = await operatorClient
    .Put(`/api/itineraries/${itineraryId}/resume`)
    .withData({
      message,
    })
    .send();

  return response;
};

export const updateTripCost = (
  itineraryId,
  price,
  premiumPrice,
  numberOfOvernights,
  numberOfRejectionOvernights,
  numberOfPickupOvernights,
) =>
  operatorClient
    .Patch(`/api/itineraries/${itineraryId}/update-price`)
    .withData({
      price,
      premium: premiumPrice,
      numberOfOvernights,
      numberOfRejectionOvernights,
      numberOfPickupOvernights,
    })
    .send();

export const uploadInvoices = async (itineraryId, fileNames) => {
  const response = await operatorClient
    .Post(`/api/fleetowner/invoices/${itineraryId}/upload`)
    .withData({
      message: 'Uploaded from the UI',
      filesUrl: fileNames.map((item) => {
        let itemType = '';
        if (item.type.includes('image')) {
          const splitted = item.type.split('/');
          itemType = splitted[1].toUpperCase();
        } else {
          itemType = 'PDF';
        }
        return {
          url: item.url,
          fileType: itemType,
        };
      }),
    })
    .send();
  return response;
};

export const downloadWaybillDocument = async (itineraryId) => {
  try {
    const response = await operatorClient
      .Get(`/api/itineraries/waybill-doc-by-filter`)
      .withParams({ itineraryIds: itineraryId })
      .send();
    return response?.results[0];
  } catch (e) {
    return null;
  }
};
